import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { userService } from '../../services/userService';

export const useUpdateCompanyPromo = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: payload =>
      userService.updateCompanyPromo(payload).then(response => {
        const { status, data } = response;

        if (status === 200) {
          queryClient.setQueryData([QUERY_KEYS.user.profile], () => data);
          return data;
        }
        return null;
      }),
  });
};
